:host {
  align-items: center;
  display: flex;
  height: max-content;
  justify-content: center;
  padding: 5px 15px;
  width: 100%;
}

:host([type='info']) {
  background-color: $color-blue-info;
  color: $color-white;
  fill: $color-white;
}

:host([type='error']) {
  border: 1px solid $color-red-error;
  color: $color-red-error;
  fill: $color-red-error;

  ::slotted(ux-copy) {
    color: $color-red-error;
  }
}

ux-icon {
  margin-right: 15px;
}

::slotted(ux-copy) {
  margin-top: 1em;
  margin-bottom: 1em;
  display: inline-block;
  color: $color-white;
}